window.DevidSearchAssistantKnowledge = {
  version: "1.1",
  updated_at: "2026-06-25",
  description: "Knowledge / Product Intent Map V1 per Search & Support Assistant. Base dati statica, compatta e futura-friendly: non contiene prezzi, disponibilità, dati ordine, credenziali o chiamate backend dirette. La AI deve essere gestita server-side tramite endpoint sicuro. Il tema Shopify non deve contenere credenziali né chiamare API private direttamente.",
  intents: [
    {
      id: "cargo_courmayeur",
      type: "product_intent",
      triggers: ["cargo uomo", "cargo courmayeur", "courmayeur", "courma", "pantalone cargo", "cargo devid label"],
      primary_label: "Cargo Courmayeur",
      primary_destination: "/products/devid-label-cargo-courmayeur-new-tabacco-dlcourmayer19304-newtabacco",
      primary_message: "Scopri il Cargo Courmayeur, uno dei pantaloni iconici Devid Label.",
      devid_label_priority: "primary",
      devid_label_alternatives: [],
      cross_sell: [
        { label: "T-shirt Mosca", destination: "/products/devid-label-t-shirt-100-cotone-scollo-a-v-bianco-mosca-dlmosca-bianco", suggestion_type: "product", reason: "Perfetta da abbinare a un cargo uomo." },
        { label: "Polo e maglie leggere Devid Label", destination: "/collections/t-shirt-polo-uomo", suggestion_type: "collection", reason: "Completano un look uomo estivo e pulito." },
        { label: "Bermuda uomo", destination: "/collections/bermuda-shorts-uomo", suggestion_type: "collection", reason: "Alternativa più estiva ai pantaloni cargo." }
      ],
      guardrails: ["Non indicare disponibilità o prezzo se non letto da Shopify."]
    },
    {
      id: "tshirt_mosca",
      type: "product_intent",
      triggers: ["t-shirt mosca", "mosca devid label", "maglia mosca", "tee mosca", "t shirt uomo devid label"],
      primary_label: "T-shirt Mosca Devid Label",
      primary_destination: "/products/devid-label-t-shirt-100-cotone-scollo-a-v-bianco-mosca-dlmosca-bianco",
      primary_message: "Ti mostro la T-shirt Mosca Devid Label e le proposte coerenti per completare il look.",
      devid_label_priority: "primary",
      devid_label_alternatives: [
        { label: "Monterosso Devid Label", destination: "/products/devid-label-t-shirt-in-filo-100-cotone-monterosso-panna-dlmonterosso-mt25100-panna", suggestion_type: "product", reason: "Alternativa più premium in filo di cotone extrafine." }
      ],
      cross_sell: [
        { label: "Bermuda uomo", destination: "/collections/bermuda-shorts-uomo", suggestion_type: "collection", reason: "Completa un outfit estivo essenziale." },
        { label: "Cargo Courmayeur", destination: "/products/devid-label-cargo-courmayeur-new-tabacco-dlcourmayer19304-newtabacco", suggestion_type: "product", reason: "Abbinamento casual con pantalone iconico Devid Label." }
      ]
    },
    {
      id: "monterosso_devid_label",
      type: "product_intent",
      triggers: ["monterosso", "monterosso devid label", "maglia monterosso", "filo cotone uomo"],
      primary_label: "Monterosso Devid Label",
      primary_destination: "/products/devid-label-t-shirt-in-filo-100-cotone-monterosso-panna-dlmonterosso-mt25100-panna",
      primary_message: "Scopri Monterosso Devid Label, una proposta più premium e raffinata per l'uomo.",
      devid_label_priority: "primary",
      devid_label_alternatives: [
        { label: "T-shirt Mosca Devid Label", destination: "/products/devid-label-t-shirt-100-cotone-scollo-a-v-bianco-mosca-dlmosca-bianco", suggestion_type: "product", reason: "Alternativa più essenziale e quotidiana." }
      ],
      cross_sell: [
        { label: "Pantaloni leggeri Devid Label", destination: "/collections/t-shirt-polo-uomo", suggestion_type: "collection", reason: "Ideali per completare un look estivo premium." }
      ]
    },
    {
      id: "jeans_globe_devid_label",
      type: "product_intent",
      triggers: ["jeans globe", "globe devid label", "jeans devid label", "denim devid label"],
      primary_label: "Jeans Globe Devid Label",
      primary_destination: "/products/devid-label-jeans-globe-dark-blue-dldenimglobeess101",
      primary_message: "Ti mostro i Jeans Globe Devid Label e gli abbinamenti più coerenti.",
      devid_label_priority: "primary",
      devid_label_alternatives: [],
      cross_sell: [
        { label: "T-shirt e polo uomo", destination: "/collections/t-shirt-polo-uomo", suggestion_type: "collection", reason: "Base semplice per completare un outfit denim." },
        { label: "T-shirt Mosca", destination: "/products/devid-label-t-shirt-100-cotone-scollo-a-v-bianco-mosca-dlmosca-bianco", suggestion_type: "product", reason: "Alternativa Devid Label essenziale da abbinare al denim." }
      ],
      guardrails: ["Non indicare lavaggi, taglie, prezzo o disponibilità se non letti da Shopify."]
    },
    {
      id: "riviera_collection",
      type: "product_intent",
      triggers: ["riviera collection", "riviera devid label", "collezione riviera", "look riviera uomo"],
      primary_label: "Riviera Collection Devid Label",
      primary_destination: "/search?q=riviera%20collection%20devid%20label",
      primary_message: "Scopri le proposte Riviera Collection Devid Label per un outfit estivo curato.",
      devid_label_priority: "primary",
      devid_label_alternatives: [],
      cross_sell: [
        { label: "Bermuda uomo", destination: "/collections/bermuda-shorts-uomo", suggestion_type: "collection", reason: "Perfetti per completare un look Riviera." },
        { label: "T-shirt e polo uomo", destination: "/collections/t-shirt-polo-uomo", suggestion_type: "collection", reason: "Abbinamenti naturali per outfit estate uomo." }
      ]
    },
    {
      id: "tshirt_saint_barth_uomo",
      type: "brand_intent_with_devid_alternative",
      triggers: ["t-shirt saint barth uomo", "mc2 t-shirt uomo", "saint barth t shirt uomo", "tshirt mc2 uomo", "maglia saint barth uomo"],
      primary_label: "T-shirt MC2 Saint Barth uomo",
      primary_destination: "/search?q=mc2%20saint%20barth%20t-shirt%20uomo",
      primary_cta_label: "Vedi risultati Saint Barth",
      primary_message: "Ti mostro prima le proposte MC2 Saint Barth coerenti con la tua ricerca.",
      devid_label_priority: "secondary",
      devid_label_alternatives: [
        { label: "T-shirt Mosca Devid Label", destination: "/products/devid-label-t-shirt-100-cotone-scollo-a-v-bianco-mosca-dlmosca-bianco", suggestion_type: "product", reason: "Alternativa Devid Label in jersey, essenziale e facile da abbinare." },
        { label: "Monterosso Devid Label", destination: "/products/devid-label-t-shirt-in-filo-100-cotone-monterosso-panna-dlmonterosso-mt25100-panna", suggestion_type: "product", reason: "Alternativa in filo di cotone extrafine, più premium." }
      ],
      cross_sell: [
        { label: "Bermuda uomo", destination: "/collections/bermuda-shorts-uomo", suggestion_type: "collection", reason: "Completa il look estivo." },
        { label: "Pantaloni leggeri Devid Label", destination: "/collections/t-shirt-polo-uomo", suggestion_type: "collection", reason: "Opzione coerente per un outfit uomo estivo." }
      ]
    },
    {
      id: "polo_mc2_uomo",
      type: "brand_intent_with_devid_alternative",
      triggers: ["polo mc2 uomo", "polo saint barth uomo", "mc2 polo uomo", "saint barth polo uomo"],
      primary_label: "Polo MC2 Saint Barth uomo",
      primary_destination: "/search?q=polo%20mc2%20saint%20barth%20uomo",
      primary_message: "Ti mostro prima le polo MC2 Saint Barth uomo coerenti con la tua ricerca.",
      devid_label_priority: "secondary",
      devid_label_alternatives: [
        { label: "Polo e t-shirt Devid Label", destination: "/collections/t-shirt-polo-uomo", suggestion_type: "collection", reason: "Alternativa Devid Label coerente nella categoria uomo." },
        { label: "Monterosso Devid Label", destination: "/products/devid-label-t-shirt-in-filo-100-cotone-monterosso-panna-dlmonterosso-mt25100-panna", suggestion_type: "product", reason: "Proposta più raffinata per un outfit estivo." }
      ],
      cross_sell: [
        { label: "Bermuda uomo", destination: "/collections/bermuda-shorts-uomo", suggestion_type: "collection", reason: "Completa il look con un capo estivo." }
      ]
    },
    {
      id: "jeans_replay_uomo",
      type: "brand_intent_with_devid_alternative",
      triggers: ["jeans replay uomo", "replay jeans uomo", "denim replay uomo"],
      primary_label: "Jeans Replay uomo",
      primary_destination: "/search?q=jeans%20replay%20uomo",
      primary_message: "Ti mostro prima i jeans Replay uomo e una alternativa Devid Label coerente.",
      devid_label_priority: "secondary",
      devid_label_alternatives: [
        { label: "Jeans Globe Devid Label", destination: "/products/devid-label-jeans-globe-dark-blue-dldenimglobeess101", suggestion_type: "product", reason: "Alternativa Devid Label per completare una ricerca denim uomo." }
      ],
      cross_sell: [
        { label: "Tee e Polo Uomo", destination: "/collections/t-shirt-polo-uomo", suggestion_type: "collection", reason: "Abbinamento semplice e coerente con il denim." }
      ],
      guardrails: ["Non indicare lavaggi disponibili se non letti da Shopify."]
    },
    {
      id: "pochette_saint_barth",
      type: "brand_intent_with_devid_alternative",
      triggers: ["pochette saint barth", "pochette mc2", "borsa mare saint barth", "accessori mare saint barth"],
      primary_label: "Pochette MC2 Saint Barth",
      primary_destination: "/search?q=pochette%20saint%20barth",
      primary_message: "Ti mostro le pochette MC2 Saint Barth e accessori mare coerenti.",
      devid_label_priority: "secondary",
      devid_label_alternatives: [],
      cross_sell: [
        { label: "Moda mare donna", destination: "/collections/moda-mare-donna", suggestion_type: "collection", reason: "Completa il look mare donna." },
        { label: "Moda mare uomo", destination: "/collections/moda-mare-uomo", suggestion_type: "collection", reason: "Abbina la pochette a capi mare uomo." },
        { label: "Accessori mare", destination: "/search?q=accessori%20mare", suggestion_type: "search", reason: "Altre proposte coerenti per il mare." }
      ],
      guardrails: ["Non proporre Devid Label se non esiste un abbinamento coerente."]
    },
    {
      id: "zaino_sprayground",
      type: "brand_intent_no_devid_alternative",
      triggers: ["zaino sprayground", "zaini sprayground", "sprayground", "backpack sprayground"],
      primary_label: "Sprayground",
      primary_destination: "/search?q=sprayground",
      primary_message: "Ti mostro i prodotti Sprayground disponibili.",
      devid_label_priority: "none",
      devid_label_alternatives: [],
      cross_sell: [
        { label: "Altri prodotti Sprayground", destination: "/search?q=sprayground", suggestion_type: "search", reason: "Mantiene la proposta sul brand richiesto." }
      ],
      guardrails: ["Non proporre Devid Label se non esiste un abbinamento outfit realmente sensato."]
    },
    {
      id: "kway_puro",
      type: "brand_intent_no_devid_alternative",
      triggers: ["k-way", "kway", "giacca k-way", "antivento k-way", "k way uomo", "k way donna"],
      primary_label: "K-Way",
      primary_destination: "/search?q=k-way",
      primary_message: "Ti mostro i prodotti K-Way coerenti con la tua ricerca.",
      devid_label_priority: "none",
      devid_label_alternatives: [],
      cross_sell: [
        { label: "Accessori K-Way", destination: "/search?q=accessori%20k-way", suggestion_type: "search", reason: "Resta nel perimetro del brand richiesto, se presenti." }
      ],
      guardrails: ["Non forzare Devid Label su ricerche K-Way pure."]
    },
    {
      id: "moda_mare_uomo",
      type: "category_intent",
      triggers: ["moda mare uomo", "mare uomo", "costume uomo", "costumi uomo", "beachwear uomo"],
      primary_label: "Moda mare uomo",
      primary_destination: "/collections/moda-mare-uomo",
      primary_message: "Ti porto alla selezione moda mare uomo.",
      devid_label_priority: "secondary",
      devid_label_alternatives: [],
      cross_sell: [
        { label: "T-shirt e polo uomo", destination: "/collections/t-shirt-polo-uomo", suggestion_type: "collection", reason: "Ideali sopra il costume." },
        { label: "Pochette mare", destination: "/search?q=pochette%20mare", suggestion_type: "search", reason: "Accessorio utile per il mare." },
        { label: "Bermuda uomo", destination: "/collections/bermuda-shorts-uomo", suggestion_type: "collection", reason: "Completa un outfit mare uomo." }
      ]
    },
    {
      id: "moda_mare_donna",
      type: "category_intent",
      triggers: ["moda mare donna", "mare donna", "costume donna", "costumi donna", "beachwear donna"],
      primary_label: "Moda mare donna",
      primary_destination: "/collections/moda-mare-donna",
      primary_message: "Ti porto alla selezione moda mare donna.",
      devid_label_priority: "none",
      devid_label_alternatives: [],
      cross_sell: [
        { label: "Top donna", destination: "/collections/t-shirt-top-donna", suggestion_type: "collection", reason: "Completa il look estivo donna." },
        { label: "Camicie donna", destination: "/collections/camicie-bluse-donna", suggestion_type: "collection", reason: "Perfette come layer leggero." }
      ]
    },
    {
      id: "bermuda_short_uomo",
      type: "category_intent",
      triggers: ["bermuda uomo", "short uomo", "shorts uomo", "pantaloncini uomo", "bermuda estivi uomo"],
      primary_label: "Bermuda e shorts uomo",
      primary_destination: "/collections/bermuda-shorts-uomo",
      primary_message: "Ti mostro bermuda e shorts uomo per outfit estivi.",
      devid_label_priority: "primary",
      devid_label_alternatives: [],
      cross_sell: [
        { label: "Polo uomo", destination: "/collections/t-shirt-polo-uomo", suggestion_type: "collection", reason: "Abbinamento classico e versatile." },
        { label: "T-shirt Mosca", destination: "/products/devid-label-t-shirt-100-cotone-scollo-a-v-bianco-mosca-dlmosca-bianco", suggestion_type: "product", reason: "Alternativa Devid Label essenziale." },
        { label: "Riviera Collection", destination: "/search?q=riviera%20collection%20devid%20label", suggestion_type: "search", reason: "Per un look estivo Devid Label." }
      ]
    },
    {
      id: "tshirt_polo_uomo",
      type: "category_intent",
      triggers: ["t-shirt uomo", "tee uomo", "polo uomo", "t shirt polo uomo", "maglie uomo estive"],
      primary_label: "T-shirt e polo uomo",
      primary_destination: "/collections/t-shirt-polo-uomo",
      primary_message: "Ti mostro t-shirt e polo uomo, con priorità alle proposte Devid Label quando coerenti.",
      devid_label_priority: "primary",
      devid_label_alternatives: [],
      cross_sell: [
        { label: "Bermuda uomo", destination: "/collections/bermuda-shorts-uomo", suggestion_type: "collection", reason: "Completa un outfit estivo." },
        { label: "Cargo Courmayeur", destination: "/products/devid-label-cargo-courmayeur-new-tabacco-dlcourmayer19304-newtabacco", suggestion_type: "product", reason: "Abbinamento casual Devid Label." }
      ]
    },
    {
      id: "top_donna",
      type: "category_intent",
      triggers: ["top donna", "t-shirt donna", "t shirt top donna", "canotte donna", "maglie donna estive"],
      primary_label: "T-shirt e top donna",
      primary_destination: "/collections/t-shirt-top-donna",
      primary_message: "Ti porto alla selezione t-shirt e top donna.",
      devid_label_priority: "none",
      devid_label_alternatives: [],
      cross_sell: [
        { label: "Moda mare donna", destination: "/collections/moda-mare-donna", suggestion_type: "collection", reason: "Completa il look estivo donna." },
        { label: "Camicie donna", destination: "/collections/camicie-bluse-donna", suggestion_type: "collection", reason: "Layer leggero per outfit donna." }
      ]
    },
    {
      id: "camicie_donna",
      type: "category_intent",
      triggers: ["camicie donna", "bluse donna", "camicie bluse donna", "camicia donna estate"],
      primary_label: "Camicie e bluse donna",
      primary_destination: "/collections/camicie-bluse-donna",
      primary_message: "Ti porto alla selezione camicie e bluse donna.",
      devid_label_priority: "none",
      devid_label_alternatives: [],
      cross_sell: [
        { label: "Top donna", destination: "/collections/t-shirt-top-donna", suggestion_type: "collection", reason: "Base facile da abbinare." },
        { label: "Moda mare donna", destination: "/collections/moda-mare-donna", suggestion_type: "collection", reason: "Per completare outfit estivi e mare." }
      ]
    },
    {
      id: "pochette_mare",
      type: "category_intent",
      triggers: ["pochette mare", "borsa mare", "accessori mare", "pochette estate"],
      primary_label: "Pochette mare",
      primary_destination: "/search?q=pochette%20mare",
      primary_message: "Ti mostro pochette e accessori mare coerenti.",
      devid_label_priority: "none",
      devid_label_alternatives: [],
      cross_sell: [
        { label: "Moda mare donna", destination: "/collections/moda-mare-donna", suggestion_type: "collection", reason: "Completa il look mare donna." },
        { label: "Moda mare uomo", destination: "/collections/moda-mare-uomo", suggestion_type: "collection", reason: "Abbina accessori a capi mare uomo." }
      ]
    },
    {
      id: "zaini",
      type: "category_intent",
      triggers: ["zaini", "zaino", "backpack", "zaini uomo", "zaini donna"],
      primary_label: "Zaini",
      primary_destination: "/search?q=zaini",
      primary_message: "Ti mostro gli zaini disponibili in base alla ricerca Shopify.",
      devid_label_priority: "none",
      devid_label_alternatives: [],
      guardrails: ["Non forzare Devid Label sulle ricerche zaini se non esiste un abbinamento coerente."]
    },
    {
      id: "sandali_donna",
      type: "category_intent",
      triggers: ["sandali donna", "sandalo donna", "scarpe estate donna", "calzature estate donna"],
      primary_label: "Sandali donna",
      primary_destination: "/search?q=sandali%20donna",
      primary_message: "Ti mostro i sandali donna coerenti con la tua ricerca.",
      devid_label_priority: "none",
      devid_label_alternatives: [],
      cross_sell: [
        { label: "Top donna", destination: "/collections/t-shirt-top-donna", suggestion_type: "collection", reason: "Completa un look estivo donna." },
        { label: "Moda mare donna", destination: "/collections/moda-mare-donna", suggestion_type: "collection", reason: "Coerente con outfit mare e vacanza." },
        { label: "Camicie donna", destination: "/collections/camicie-bluse-donna", suggestion_type: "collection", reason: "Layer leggero per outfit estivi." }
      ]
    },
    {
      id: "jeans_uomo",
      type: "category_intent",
      triggers: ["jeans uomo", "denim uomo", "pantaloni jeans uomo"],
      primary_label: "Jeans uomo",
      primary_destination: "/search?q=jeans%20uomo",
      primary_message: "Ti mostro i jeans uomo e, quando coerente, alternative Devid Label.",
      devid_label_priority: "secondary",
      devid_label_alternatives: [
        { label: "Jeans Globe Devid Label", destination: "/products/devid-label-jeans-globe-dark-blue-dldenimglobeess101", suggestion_type: "product", reason: "Alternativa Devid Label per la categoria denim uomo." }
      ],
      cross_sell: [
        { label: "T-shirt e polo uomo", destination: "/collections/t-shirt-polo-uomo", suggestion_type: "collection", reason: "Abbinamento semplice con denim." }
      ]
    },
    {
      id: "cargo_uomo",
      type: "category_intent",
      triggers: ["cargo uomo", "pantalone cargo uomo", "pantaloni cargo uomo"],
      primary_label: "Cargo uomo",
      primary_destination: "/search?q=cargo%20uomo",
      primary_message: "Ti mostro i cargo uomo dando priorità alle proposte Devid Label coerenti.",
      devid_label_priority: "primary",
      devid_label_alternatives: [
        { label: "Cargo Courmayeur", destination: "/products/devid-label-cargo-courmayeur-new-tabacco-dlcourmayer19304-newtabacco", suggestion_type: "product", reason: "Proposta iconica Devid Label nella categoria cargo." }
      ],
      cross_sell: [
        { label: "T-shirt Mosca", destination: "/products/devid-label-t-shirt-100-cotone-scollo-a-v-bianco-mosca-dlmosca-bianco", suggestion_type: "product", reason: "Abbinamento immediato con cargo uomo." },
        { label: "Monterosso Devid Label", destination: "/products/devid-label-t-shirt-in-filo-100-cotone-monterosso-panna-dlmonterosso-mt25100-panna", suggestion_type: "product", reason: "Maglia più premium da abbinare a cargo e pantaloni uomo." },
        { label: "T-shirt e polo uomo", destination: "/collections/t-shirt-polo-uomo", suggestion_type: "collection", reason: "Categoria sicura per completare il look." }
      ]
    },
    {
      id: "outfit_mare_uomo",
      type: "category_intent",
      triggers: ["outfit mare uomo", "look mare uomo", "abbinamento mare uomo"],
      primary_label: "Outfit mare uomo",
      primary_destination: "/collections/moda-mare-uomo",
      primary_message: "Parti dalla moda mare uomo e completa il look con t-shirt, polo, pochette e bermuda.",
      devid_label_priority: "secondary",
      cross_sell: [
        { label: "T-shirt e polo uomo", destination: "/collections/t-shirt-polo-uomo", suggestion_type: "collection", reason: "Ideali sopra il costume." },
        { label: "Bermuda uomo", destination: "/collections/bermuda-shorts-uomo", suggestion_type: "collection", reason: "Completa un outfit da vacanza." },
        { label: "Pochette mare", destination: "/search?q=pochette%20mare", suggestion_type: "search", reason: "Accessorio utile per il mare." }
      ]
    },
    {
      id: "outfit_estate_uomo",
      type: "category_intent",
      triggers: ["outfit estate uomo", "look estate uomo", "abbinamento estivo uomo", "vestiti estate uomo"],
      primary_label: "Outfit estate uomo",
      primary_destination: "/collections/t-shirt-polo-uomo",
      primary_message: "Ti aiuto a costruire un outfit estate uomo partendo da t-shirt, polo, bermuda e proposte Devid Label.",
      devid_label_priority: "primary",
      devid_label_alternatives: [
        { label: "Riviera Collection Devid Label", destination: "/search?q=riviera%20collection%20devid%20label", suggestion_type: "search", reason: "Selezione coerente per look uomo estivi." }
      ],
      cross_sell: [
        { label: "Bermuda uomo", destination: "/collections/bermuda-shorts-uomo", suggestion_type: "collection", reason: "Base estiva per completare il look." },
        { label: "T-shirt Mosca", destination: "/products/devid-label-t-shirt-100-cotone-scollo-a-v-bianco-mosca-dlmosca-bianco", suggestion_type: "product", reason: "Capo essenziale Devid Label." }
      ]
    },
    {
      id: "regalo_uomo",
      type: "category_intent",
      triggers: ["regalo uomo", "idee regalo uomo", "cosa regalare uomo", "regalo estate uomo"],
      primary_label: "Idee regalo uomo",
      primary_destination: "/collections/t-shirt-polo-uomo",
      primary_message: "Ti propongo idee regalo uomo partendo da t-shirt, polo e capi facili da indossare.",
      devid_label_priority: "primary",
      cross_sell: [
        { label: "Bermuda uomo", destination: "/collections/bermuda-shorts-uomo", suggestion_type: "collection", reason: "Idea regalo estiva e versatile." },
        { label: "Cargo Courmayeur", destination: "/products/devid-label-cargo-courmayeur-new-tabacco-dlcourmayer19304-newtabacco", suggestion_type: "product", reason: "Proposta Devid Label più distintiva." }
      ],
      guardrails: ["Non promettere cambi o resi oltre le policy mostrate dal tema o dall'assistenza."]
    },
    {
      id: "regalo_donna",
      type: "category_intent",
      triggers: ["regalo donna", "idee regalo donna", "cosa regalare donna", "regalo estate donna"],
      primary_label: "Idee regalo donna",
      primary_destination: "/collections/t-shirt-top-donna",
      primary_message: "Ti propongo idee regalo donna partendo da top, camicie e proposte estate.",
      devid_label_priority: "none",
      cross_sell: [
        { label: "Camicie donna", destination: "/collections/camicie-bluse-donna", suggestion_type: "collection", reason: "Idea regalo elegante e versatile." },
        { label: "Moda mare donna", destination: "/collections/moda-mare-donna", suggestion_type: "collection", reason: "Proposta adatta alla stagione estiva." }
      ],
      guardrails: ["Non proporre Devid Label se non esiste una proposta donna coerente."]
    }
  ],
  faq: [
    {
      id: "prodotti_originali",
      triggers: ["prodotti originali", "sono originali", "sono autentici", "i prodotti sono originali", "vendete prodotti originali", "la merce è originale", "originali?", "brand originali", "autenticità"],
      question: "I prodotti sono originali?",
      answer: "Sì, i prodotti dei brand esterni sono originali. Devid Label è il nostro brand proprietario.",
      requires_backend: false
    },
    {
      id: "tempi_spedizione",
      triggers: ["tempi spedizione", "tempi di spedizione", "quando arriva", "spedizione"],
      question: "Quali sono i tempi di spedizione?",
      answer: "I tempi dipendono dal metodo scelto e dalla destinazione. Le opzioni disponibili vengono mostrate al checkout. Non vengono effettuate spedizioni il sabato e la domenica.",
      requires_backend: false
    },
    {
      id: "inpost_gratis",
      triggers: ["inpost", "inpost gratis", "locker gratis", "punto inpost", "spedizione inpost"],
      question: "InPost è gratis?",
      answer: "La spedizione InPost è sempre gratis scegliendo Locker o Punto InPost al checkout.",
      requires_backend: false
    },
    {
      id: "pagamento_consegna",
      triggers: ["pagamento alla consegna", "contrassegno", "posso pagare alla consegna", "pago alla consegna"],
      question: "Posso pagare alla consegna?",
      answer: "Il pagamento alla consegna è disponibile scegliendo la spedizione a domicilio al checkout. Non è disponibile con InPost, Locker o Punti InPost.",
      requires_backend: false
    },
    {
      id: "reso_facile",
      triggers: ["reso", "reso facile", "restituzione", "come fare reso"],
      question: "Come funziona il reso?",
      answer: "Il reso è semplice. Le condizioni aggiornate sono indicate nella policy resi del sito.",
      requires_backend: false
    },
    {
      id: "guida_taglie",
      triggers: ["guida taglie", "taglia", "che taglia", "vestibilità"],
      question: "Come scelgo la taglia?",
      answer: "Quando disponibile, trovi la guida taglie direttamente nella scheda prodotto. Se sei indeciso tra due taglie, controlla sempre la vestibilità indicata.",
      requires_backend: false
    },
    {
      id: "dove_mio_ordine",
      triggers: ["dov'è il mio ordine", "dove è il mio ordine", "dove si trova il mio ordine", "tracking ordine", "stato ordine", "ordine non arrivato"],
      question: "Dov'è il mio ordine?",
      answer: "Per proteggere i tuoi dati, da questa schermata non possiamo ancora verificare automaticamente lo stato dell'ordine. Usa il link di tracking ricevuto via email oppure conserva numero ordine ed email: nella prossima versione potremo verificare lo stato direttamente da qui.",
      requires_backend: true
    },
    {
      id: "cambio_taglia",
      triggers: ["cambio taglia", "cambiare taglia", "taglia sbagliata", "sostituzione taglia"],
      question: "Posso cambiare taglia?",
      answer: "Il reso è semplice. Le condizioni aggiornate sono indicate nella policy resi del sito.",
      requires_backend: false
    }

  ],

  /*
    Future AI response contract (documentazione non attiva):
    {
      "type": "product_advice | faq | order_help | fallback",
      "title": "...",
      "message": "...",
      "primary_cta": {
        "label": "...",
        "url": "..."
      },
      "devid_label_alternatives": [],
      "cross_sell": [],
      "requires_backend": false
    }
  */

  product_url_catalog: {
    jeans_globe: [
      "/products/devid-label-jeans-globe-dark-blue-dldenimglobeess101",
      "/products/devid-label-jeans-globe-indigo-strong-blue-dldenimglobe17051",
      "/products/devid-label-jeans-globe-medium-blue-dldenimglobeess105",
      "/products/devid-label-jeans-globe-marble-dldenimglobemarble"
    ],
    tshirt_mosca: [
      "/products/devid-label-t-shirt-100-cotone-scollo-a-v-bianco-mosca-dlmosca-bianco",
      "/products/devid-label-t-shirt-100-cotone-scollo-a-v-blu-navy-mosca-dlmosca-blu-navy",
      "/products/devid-label-t-shirt-100-cotone-scollo-a-v-nero-mosca-dlmosca-nero"
    ],
    monterosso: [
      "/products/devid-label-t-shirt-in-filo-100-cotone-monterosso-panna-dlmonterosso-mt25100-panna",
      "/products/devid-label-t-shirt-in-filo-100-cotone-monterosso-blu-navy-dlmonterosso-mt25100-blunavy",
      "/products/devid-label-t-shirt-in-filo-100-cotone-monterosso-nero-dlmonterosso-mt25100-nero"
    ],
    bermuda_amalfi: [
      "/products/devid-label-amalfi-bermuda-chic-con-pences-blu-navy-dlamalfiess2020c5blunavy",
      "/products/devid-label-amalfi-bermuda-chic-con-pences-sabbia-dlamalfiess2020c13sabbia",
      "/products/devid-label-amalfi-bermuda-chic-con-pences-salvia-dlamalfiess2020c22salvia"
    ],
    cargo_courmayeur: [
      "/products/devid-label-cargo-courmayeur-new-tabacco-dlcourmayer19304-newtabacco",
      "/products/devid-label-cargo-courmayeur-old-military-dlcourmayer19304-military",
      "/products/devid-label-cargo-courmayeur-grigio-scuro-dlcourmayer19304-grigiosc"
    ]
  },
  commercial_rules: [
    {
      id: "devid_label_primary",
      action: "promote_devid_label_primary",
      label: "Spingere Devid Label come proposta primaria",
      applies_to: ["query generica uomo", "cargo uomo", "bermuda uomo", "pantalone uomo estivo", "polo uomo", "t-shirt uomo", "maglieria uomo", "Riviera Collection", "Devid Label"],
      rationale: "Categorie e query dove Devid Label è coerente come proposta principale."
    },
    {
      id: "devid_label_secondary",
      action: "promote_devid_label_secondary",
      label: "Spingere Devid Label come alternativa secondaria",
      applies_to: ["query brand esterno compatibile con categoria Devid Label", "t-shirt Saint Barth uomo", "polo MC2 uomo", "jeans Replay uomo", "pantalone uomo generico", "outfit uomo estivo"],
      rationale: "La richiesta primaria resta sul brand/categoria cercata, ma Devid Label può essere suggerito come alternativa coerente."
    },
    {
      id: "devid_label_do_not_push",
      action: "do_not_promote_devid_label",
      label: "Non spingere Devid Label",
      applies_to: ["zaino Sprayground", "K-Way puro", "scarpe Mou", "Blundstone", "Flower Mountain", "query brandizzata donna senza proposta Devid Label coerente", "prodotto/categoria non coperta da Devid Label"],
      rationale: "Evitare suggerimenti forzati o incoerenti con l'intento espresso dall'utente."
    }
  ],
  cross_sell_rules: [
    {
      id: "cargo_courmayeur_cross_sell",
      source: "Cargo Courmayeur",
      suggestions: [
        { label: "T-shirt Mosca", destination: "/products/devid-label-t-shirt-100-cotone-scollo-a-v-bianco-mosca-dlmosca-bianco", suggestion_type: "product", reason: "Perfetta da abbinare a un cargo uomo." },
        { label: "Polo/maglie leggere Devid Label", destination: "/collections/t-shirt-polo-uomo", suggestion_type: "collection", reason: "Completano un outfit estivo uomo." },
        { label: "Bermuda/pantaloni Devid Label", destination: "/products/devid-label-cargo-courmayeur-new-tabacco-dlcourmayer19304-newtabacco", suggestion_type: "product", reason: "Alternative coerenti nella parte bassa uomo." }
      ]
    },
    {
      id: "bermuda_uomo_cross_sell",
      source: "Bermuda uomo",
      suggestions: [
        { label: "Polo uomo", destination: "/collections/t-shirt-polo-uomo", suggestion_type: "collection", reason: "Abbinamento classico da estate." },
        { label: "T-shirt Mosca", destination: "/products/devid-label-t-shirt-100-cotone-scollo-a-v-bianco-mosca-dlmosca-bianco", suggestion_type: "product", reason: "Essenziale e facile da indossare." },
        { label: "Riviera Collection", destination: "/search?q=riviera%20collection%20devid%20label", suggestion_type: "search", reason: "Look estivo Devid Label più curato." }
      ]
    },
    {
      id: "tshirt_saint_barth_uomo_cross_sell",
      source: "T-shirt Saint Barth uomo",
      suggestions: [
        { label: "Alternativa Devid Label Mosca/Monterosso", destination: "/search?q=mosca%20monterosso%20devid%20label", suggestion_type: "search", reason: "Alternative Devid Label coerenti con t-shirt e maglie uomo." },
        { label: "Bermuda uomo", destination: "/collections/bermuda-shorts-uomo", suggestion_type: "collection", reason: "Completa il look estivo." },
        { label: "Pantaloni leggeri Devid Label", destination: "/collections/t-shirt-polo-uomo", suggestion_type: "collection", reason: "Abbinamento estivo uomo." }
      ]
    },
    {
      id: "jeans_replay_uomo_cross_sell",
      source: "Jeans Replay uomo",
      suggestions: [
        { label: "Alternativa Devid Label Globe", destination: "/products/devid-label-jeans-globe-dark-blue-dldenimglobeess101", suggestion_type: "product", reason: "Alternativa denim Devid Label." },
        { label: "T-shirt/polo Devid Label", destination: "/collections/t-shirt-polo-uomo", suggestion_type: "collection", reason: "Abbinamento naturale con jeans." },
        { label: "Camicia uomo", destination: "/search?q=camicia%20uomo", suggestion_type: "search", reason: "Opzione smart casual se presente a catalogo." }
      ]
    },
    {
      id: "pochette_saint_barth_cross_sell",
      source: "Pochette Saint Barth",
      suggestions: [
        { label: "Moda mare donna", destination: "/collections/moda-mare-donna", suggestion_type: "collection", reason: "Completa il look mare donna." },
        { label: "Moda mare uomo", destination: "/collections/moda-mare-uomo", suggestion_type: "collection", reason: "Completa il look mare uomo." },
        { label: "Accessori mare", destination: "/search?q=accessori%20mare", suggestion_type: "search", reason: "Proposte accessorio coerenti." }
      ]
    },
    {
      id: "costume_uomo_cross_sell",
      source: "Costume uomo",
      suggestions: [
        { label: "Bermuda uomo Devid Label", destination: "/collections/bermuda-shorts-uomo", suggestion_type: "collection", reason: "Completa un outfit mare uomo." },
        { label: "T-shirt/polo uomo", destination: "/collections/t-shirt-polo-uomo", suggestion_type: "collection", reason: "Da indossare sopra il costume." },
        { label: "Riviera Collection", destination: "/search?q=riviera%20collection", suggestion_type: "search", reason: "Selezione coerente per un look mare estivo." }
      ]
    },
    {
      id: "sandali_donna_cross_sell",
      source: "Sandali donna",
      suggestions: [
        { label: "Top donna", destination: "/collections/t-shirt-top-donna", suggestion_type: "collection", reason: "Completa un look estivo." },
        { label: "Moda mare donna", destination: "/collections/moda-mare-donna", suggestion_type: "collection", reason: "Coerente con outfit mare e vacanza." },
        { label: "Camicie donna", destination: "/collections/camicie-bluse-donna", suggestion_type: "collection", reason: "Layer leggero per outfit estivi." }
      ]
    },
    {
      id: "kway_cross_sell",
      source: "K-Way",
      suggestions: [
        { label: "Accessori K-Way", destination: "/search?q=accessori%20k-way", suggestion_type: "search", reason: "Resta nel perimetro del brand richiesto, se presenti." }
      ],
      guardrails: ["Non forzare Devid Label."]
    },
    {
      id: "sprayground_cross_sell",
      source: "Sprayground",
      suggestions: [
        { label: "Altri prodotti Sprayground", destination: "/search?q=sprayground", suggestion_type: "search", reason: "Resta sul brand richiesto." }
      ],
      guardrails: ["Non forzare Devid Label salvo abbinamento outfit realmente sensato."]
    }
  ],

  cart_upsell_rules: [
    {
      id: "mc2_tshirt_polo_uomo_to_devid_label",
      trigger: {
        vendors: ["MC2 Saint Barth"],
        product_types: ["T-shirt", "Polo", "Maglia"],
        keywords: ["t-shirt", "t shirt", "tee", "polo", "maglia", "uomo"],
        gender: "uomo"
      },
      recommendation_type: "alternative",
      priority: 90,
      title: "Alternativa Devid Label",
      message: "Prova anche un'alternativa Devid Label.",
      suggestions: [
        { label: "T-shirt Mosca Devid Label", destination: "/products/devid-label-t-shirt-100-cotone-scollo-a-v-bianco-mosca-dlmosca-bianco", suggestion_type: "product", reason: "Jersey essenziale e facile da abbinare." },
        { label: "Monterosso Devid Label", destination: "/products/devid-label-t-shirt-in-filo-100-cotone-monterosso-panna-dlmonterosso-mt25100-panna", suggestion_type: "product", reason: "Maglia in filo di cotone extrafine, più premium." },
        { label: "TEE E POLO UOMO", destination: "/collections/t-shirt-polo-uomo", suggestion_type: "collection", reason: "Selezione sicura per alternative uomo." }
      ],
      discount_eligible: false,
      future_discount: false
    },
    {
      id: "replay_jeans_uomo_to_devid_label",
      trigger: { vendors: ["Replay"], product_types: ["Jeans", "Denim", "Pantaloni"], keywords: ["jeans", "denim", "uomo"], gender: "uomo" },
      recommendation_type: "alternative",
      priority: 85,
      title: "Alternativa Devid Label",
      message: "Abbina un capo Devid Label al tuo ordine.",
      suggestions: [
        { label: "Jeans Globe Devid Label", destination: "/products/devid-label-jeans-globe-dark-blue-dldenimglobeess101", suggestion_type: "product", reason: "Alternativa denim Devid Label coerente." },
        { label: "T-shirt e polo Devid Label", destination: "/collections/t-shirt-polo-uomo", suggestion_type: "collection", reason: "Abbinamento semplice con il denim." }
      ],
      discount_eligible: false,
      future_discount: false
    },
    {
      id: "costume_mare_uomo_to_devid_label",
      trigger: { vendors: ["MC2 Saint Barth", "Tooco"], product_types: ["Costume", "Boxer", "Moda mare"], keywords: ["costume", "boxer", "mare", "beachwear", "uomo"], gender: "uomo" },
      recommendation_type: "cross_sell",
      priority: 80,
      title: "Completa il look",
      message: "Completa il look mare.",
      suggestions: [
        { label: "Bermuda uomo Devid Label", destination: "/collections/bermuda-shorts-uomo", suggestion_type: "collection", reason: "Perfetti per completare un outfit mare uomo." },
        { label: "TEE E POLO UOMO", destination: "/collections/t-shirt-polo-uomo", suggestion_type: "collection", reason: "Da indossare sopra il costume." },
        { label: "Riviera Collection", destination: "/search?q=riviera%20collection", suggestion_type: "search", reason: "Ricerca dedicata ai look estivi." }
      ],
      discount_eligible: false,
      future_discount: false
    },
    {
      id: "cargo_pantaloni_uomo_devid_label_cross_sell",
      trigger: { vendors: ["Devid Label"], product_types: ["Cargo", "Pantaloni"], keywords: ["cargo", "courmayeur", "pantalone", "pantaloni", "uomo"], gender: "uomo" },
      recommendation_type: "cross_sell",
      priority: 75,
      title: "Da abbinare",
      message: "Abbina un capo Devid Label al tuo ordine.",
      suggestions: [
        { label: "T-shirt Mosca", destination: "/products/devid-label-t-shirt-100-cotone-scollo-a-v-bianco-mosca-dlmosca-bianco", suggestion_type: "product", reason: "Abbinamento immediato con cargo e pantaloni uomo." },
        { label: "Monterosso Devid Label", destination: "/products/devid-label-t-shirt-in-filo-100-cotone-monterosso-panna-dlmonterosso-mt25100-panna", suggestion_type: "product", reason: "Maglia più premium per completare il look." },
        { label: "TEE E POLO UOMO", destination: "/collections/t-shirt-polo-uomo", suggestion_type: "collection", reason: "Categoria sicura per completare outfit uomo." }
      ],
      discount_eligible: false,
      future_discount: false
    },
    {
      id: "mc2_pochette_mare_no_forced_devid_label",
      trigger: { vendors: ["MC2 Saint Barth"], product_types: ["Accessori", "Pochette"], keywords: ["pochette", "vanity", "beauty", "borsa mare"] },
      recommendation_type: "cross_sell",
      priority: 60,
      title: "Completa il look",
      message: "Completa il look mare con categorie coerenti.",
      suggestions: [
        { label: "Moda mare donna", destination: "/collections/moda-mare-donna", suggestion_type: "collection", reason: "Categoria coerente con accessori mare donna." },
        { label: "Moda mare uomo", destination: "/collections/moda-mare-uomo", suggestion_type: "collection", reason: "Categoria coerente con accessori mare uomo." }
      ],
      discount_eligible: false,
      future_discount: false,
      guardrails: ["Non forzare Devid Label se non c'è proposta coerente."]
    },
    {
      id: "sprayground_accessori_no_devid_label",
      trigger: { vendors: ["Sprayground"], product_types: ["Zaini", "Borse", "Accessori"], keywords: ["zaino", "zaini", "borsa", "accessori", "backpack"] },
      recommendation_type: "same_brand",
      priority: 50,
      title: "Altri accessori",
      message: "Resta sul brand richiesto.",
      suggestions: [
        { label: "Altri prodotti Sprayground", destination: "/search?q=sprayground", suggestion_type: "search", reason: "Proposte coerenti con il brand nel carrello." }
      ],
      discount_eligible: false,
      future_discount: false,
      guardrails: ["Non forzare Devid Label su zaini, borse e accessori Sprayground."]
    },
    {
      id: "kway_same_brand_no_devid_label",
      trigger: { vendors: ["K-Way"], product_types: ["Giacca", "Accessori"], keywords: ["k-way", "kway", "antivento", "giacca"] },
      recommendation_type: "same_brand",
      priority: 45,
      title: "Completa con K-Way",
      message: "Resta sul brand richiesto.",
      suggestions: [
        { label: "Accessori K-Way", destination: "/search?q=accessori%20k-way", suggestion_type: "search", reason: "Suggerimento non invasivo sullo stesso brand, se presente." }
      ],
      discount_eligible: false,
      future_discount: false,
      guardrails: ["Non forzare Devid Label su carrelli K-Way puri."]
    },
    {
      id: "scarpe_sandali_donna_soft_cross_sell",
      trigger: { vendors: ["Mou", "Flower Mountain", "Blundstone"], product_types: ["Scarpe", "Sandali", "Calzature"], keywords: ["sandali", "scarpe", "donna"] },
      recommendation_type: "cross_sell",
      priority: 40,
      title: "Completa il look",
      message: "Completa il look donna con categorie leggere.",
      suggestions: [
        { label: "Top donna", destination: "/collections/t-shirt-top-donna", suggestion_type: "collection", reason: "Base facile per outfit estivi donna." },
        { label: "Camicie donna", destination: "/collections/camicie-bluse-donna", suggestion_type: "collection", reason: "Layer leggero e versatile." },
        { label: "Moda mare donna", destination: "/collections/moda-mare-donna", suggestion_type: "collection", reason: "Coerente con look estate e vacanza." }
      ],
      discount_eligible: false,
      future_discount: false,
      guardrails: ["Non usare copy aggressivo Devid Label se non coerente."]
    }
  ],
  guardrails: [
    "Non inventare disponibilità.",
    "Non inventare prezzi.",
    "Non inventare tracking.",
    "Non promettere spedizione sabato/domenica.",
    "Non dire che il contrassegno è disponibile con InPost.",
    "Non dire \"Made in Italy\" se non verificato sul prodotto.",
    "Non forzare Devid Label quando non coerente.",
    "Per stato ordine servono numero ordine + email e backend sicuro.",
    "Il tema Shopify non deve contenere credenziali.",
    "La futura AI deve usare dati verificati."
  ],
  future_backend_requirements: [
    "catalogo indicizzato",
    "disponibilità",
    "prezzo",
    "taglia",
    "vendor",
    "product type",
    "collection",
    "metafield",
    "order lookup via backend",
    "API private Shopify solo server-side",
    "email + numero ordine per verificare status",
    "tracking/corriere/status",
    "logging privacy-safe"
  ]
};
